class AccountSettings.AllowedDomainsEditorView extends Backbone.View
  template: JST["backbone/templates/account_settings/allowed_domains/edit_modal"]
  blank_model: Backbone.Model.extend({})

  initialize: (@options = {}) ->
    @model = @options.model
    @collection = @options.collection
    @modal = @_getModal()
    @modalView = new App.ModalView({instance: @})

  render: ->
    @$el.html(@template({ self: @ }))
    @modalView.firstTab._activate()

  exit: =>
    console.log "exit event"
    @modalView.destroy()

  save: =>
    domain = @$el.find('#edit-domain-value').val()
    return @_handleInvalidError() unless @_domainIsValid(domain)
    if @_isNew()
      @doCreateDomain(domain)
    else
      @doUpdateDomain(domain)

  activate: =>
    @modalTab._activate()

  doUpdateDomain: (domain) =>
    @model.setDomain(domain)
    @model.save({domain: domain}, { success: @_afterModelUpdate })
    @modalView.destroy()

  doCreateDomain: (domain) =>
    @model.setDomain(domain)
    @model.save(null, { success: @_afterModelCreated })
    @$el.find('.btn-add').removeAttr('disabled')

  _afterModelCreated: (model, response) =>
    model.setId(response.data.id)
    @trigger('new:allowedDomain', model)
    @modalView.destroy()

  _afterModelUpdate:(model, response) =>
    @trigger('updated:allowedDomain', model)
    @modalView.destroy()

  _valueOfModel: ->
    return '' if @_isNew()
    @model.getDomain()

  _domainIsValid: (domain) =>
    domain? && domain.trim() != ''

  _handleInvalidError: ->
    swal(I18n.t('account_settings.allowed_domains.error.title'), I18n.t('account_settings.allowed_domains.error.message'), 'error')

  _isNew: ->
    !@model.getDomain()?

  _getModal: ->
    {
      title: I18n.t("account_settings.allowed_domains.editor.title.#{if @_isNew then 'new' else 'edit'}")
      buttons: [
        {
          title: I18n.t('account_settings.allowed_domains.editor.save'),
          event: 'save'
        },
        {
          title: I18n.t('account_settings.allowed_domains.editor.cancel'),
          event: 'exit'
        },
      ]
    }